module.exports = __webpack_public_path__ + "static/media/fr.ad12a30f.svg";